import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-69153d9e")

_pushScopeId("data-v-69153d9e")
const _hoisted_1 = {
  key: 0,
  class: "p-text-nowrap p-mr-2 p-px-1 model-count"
}
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "" }
const _hoisted_7 = { class: "" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Column = _resolveComponent("Column")!
  const _component_ExperimentTag = _resolveComponent("ExperimentTag")!
  const _component_KpiTag = _resolveComponent("KpiTag")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("h5", null, [
      _createTextVNode(_toDisplayString(_ctx.$t("label.leaderboard")) + " ", 1),
      (_ctx.modelCount)
        ? (_openBlock(), _createBlock("span", _hoisted_1, _toDisplayString(_ctx.$t("label.leaderboard.model.count", { value: _ctx.modelCount })), 1))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_DataTable, {
      removableSort: "",
      responsiveLayout: "scroll",
      loading: _ctx.loading,
      "sort-field": _ctx.sortField,
      "sort-order": _ctx.sortOrder,
      value: _ctx.leaderBoard
    }, {
      empty: _withId(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("datasource.sample_data.no.data.found")), 1)
      ]),
      loading: _withId(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("datasource.sample_data.loading.data.please.wait")), 1)
      ]),
      default: _withId(() => [
        _createVNode(_component_Column, {
          field: "name",
          header: _ctx.$t('automl.evaluation.leaderBoard.headers.modelName'),
          key: "id",
          sortable: true
        }, {
          body: _withId(({ data }) => [
            _createVNode("div", _hoisted_2, [
              _createVNode("span", null, _toDisplayString(data.name), 1)
            ])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          field: "modelType",
          header: _ctx.$t('automl.evaluation.leaderBoard.headers.modelType'),
          key: "id",
          sortable: true
        }, {
          body: _withId(({ data }) => [
            _createVNode("div", _hoisted_3, [
              _createVNode("span", null, _toDisplayString(data.modelType), 1),
              (data.isExplainable)
                ? (_openBlock(), _createBlock(_component_ExperimentTag, {
                    key: 0,
                    name: 'EXPLAINABLE',
                    class: "p-ml-2"
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          field: "stackLevel",
          header: _ctx.$t('automl.evaluation.leaderBoard.headers.stackLevel'),
          key: "id",
          sortable: true
        }, {
          body: _withId(({ data }) => [
            _createVNode("span", null, _toDisplayString(data.stackLevel), 1)
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          field: "fitTime",
          header: _ctx.$t('automl.evaluation.leaderBoard.headers.fitTime'),
          key: "id",
          sortable: true
        }, {
          body: _withId(({ data }) => [
            (data.fitTime)
              ? _withDirectives((_openBlock(), _createBlock("span", _hoisted_4, [
                  _createTextVNode(_toDisplayString(_ctx.$moment.duration(data.fitTime, "seconds").humanize()), 1)
                ], 512)), [
                  [_directive_tooltip, `${_ctx.$getDuration(data.fitTime)}`]
                ])
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          field: "predictTime",
          header: _ctx.$t('automl.evaluation.leaderBoard.headers.predictTime'),
          key: "id",
          sortable: true
        }, {
          body: _withId(({ data }) => [
            (data.predictTime)
              ? _withDirectives((_openBlock(), _createBlock("span", _hoisted_5, [
                  _createTextVNode(_toDisplayString(_ctx.$moment.duration(data.predictTime, "seconds").humanize()), 1)
                ], 512)), [
                  [_directive_tooltip, `${_ctx.$getDuration(data.predictTime)}`]
                ])
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          field: "valScore",
          header: _ctx.$t('automl.evaluation.leaderBoard.headers.validationScore'),
          key: "id",
          sortable: true
        }, {
          body: _withId(({ data }) => [
            _createVNode("div", _hoisted_6, [
              _createVNode(_component_KpiTag, {
                name: data.primaryMetric,
                value: data.valScore,
                best: data.valScore === _ctx.bestValidationScore,
                percentage: data.percentage
              }, null, 8, ["name", "value", "best", "percentage"])
            ])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          field: "testScore",
          header: _ctx.$t('automl.evaluation.leaderBoard.headers.testScore'),
          key: "id",
          sortable: true
        }, {
          body: _withId(({ data }) => [
            _createVNode("div", _hoisted_7, [
              _createVNode(_component_KpiTag, {
                name: data.primaryMetric,
                value: data.testScore,
                best: data.testScore === _ctx.bestTestScore,
                percentage: data.percentage
              }, null, 8, ["name", "value", "best", "percentage"])
            ])
          ]),
          _: 1
        }, 8, ["header"])
      ]),
      _: 1
    }, 8, ["loading", "sort-field", "sort-order", "value"])
  ], 64))
})